import * as Yup from 'yup';

const createEditGroupValidationSchema = Yup.object().shape({
  groupName: Yup.string()
    .max(100, 'Group name must have less than 100 characters')
    .required('Please enter the group name')
});

export default createEditGroupValidationSchema;
